import React, { useEffect, useState } from 'react';
import { ServiceDetailPageContainer, ServiceImage } from './ServiceDetailPage';
import { FaPaperPlane } from 'react-icons/fa';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';


const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 8rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

export const ContactTitle = styled.h2`
  color: #fff !important;
  margin-top: 0 !important;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled.button`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

function WordPressServices() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers and limit to exactly 11 digits
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ServiceDetailPageContainer>
      <h1>WordPress Hizmetleri</h1>
      <p>WordPress tabanlı web siteleriniz için özelleştirme, bakım ve güvenlik hizmetleri sunuyoruz. İhtiyaçlarınıza özel çözümlerle web sitenizin performansını artırıyor ve sorunsuz çalışmasını sağlıyoruz.</p>

      <ServiceImage src="/media/demirer-ajans-6.png" alt="WordPress Hizmetleri Görseli 1" />

      <h2>Neden WordPress Hizmetleri Önemlidir?</h2>
      <p>WordPress, dünya genelinde en çok kullanılan içerik yönetim sistemidir. Esnek yapısı, geniş eklenti ve tema ekosistemi sayesinde her türlü web sitesi ihtiyacına cevap verebilir. Ancak, performans, güvenlik ve SEO gibi konularda uzman desteği almak, sitenizin tam potansiyelini kullanması için kritiktir.</p>

      <ServiceImage src="/media/demirer-ajans-7.png" alt="WordPress Hizmetleri Görseli 2" />

      <h3>Hizmetlerimiz Neleri Kapsar?</h3>
      <ul>
        <li><b>Kurulum ve Konfigürasyon:</b> WordPress sitenizin sıfırdan kurulumu ve optimal şekilde yapılandırılması.</li>
        <li><b>Tema ve Eklenti Entegrasyonu:</b> İhtiyaçlarınıza uygun tema seçimi, özelleştirme ve gerekli eklentilerin sorunsuz entegrasyonu.</li>
        <li><b>Performans Optimizasyonu:</b> Web sitenizin yükleme hızını artırmak için teknik optimizasyonlar (önbellekleme, görsel optimizasyonu vb.).</li>
        <li><b>SEO Optimizasyonu:</b> WordPress sitenizin arama motorlarında daha iyi sıralama alması için gerekli tüm SEO ayarları.</li>
        <li><b>Güvenlik Hizmetleri:</b> Güvenlik duvarı kurulumu, kötü amaçlı yazılım temizliği, düzenli güvenlik taramaları ve yedeklemeler.</li>
        <li><b>Bakım ve Güncelleme:</b> WordPress çekirdeği, tema ve eklentilerin düzenli olarak güncellenmesi ve sitenizin sorunsuz çalışmasının sağlanması.</li>
        <li><b>Hata Giderme ve Destek:</b> Web sitenizde meydana gelen tüm teknik sorunlara hızlı ve etkili çözümler sunma.</li>
        <li><b>Veri Taşıma ve Migrasyon:</b> Mevcut web sitenizin başka bir sunucuya veya WordPress altyapısına sorunsuz taşınması.</li>
      </ul>

      <h2>WordPress Siteniz İçin Nasıl Destek Sağlıyoruz?</h2>
      <ServiceImage src="/media/demirer-ajans-1.png" alt="WordPress Hizmetleri Görseli 3" />
      <p>WordPress uzmanlarımız, sitenizin her aşamasında size profesyonel destek sunar. Yeni bir site kurmaktan, mevcut sitenizin performansını artırmaya ve güvenliğini sağlamaya kadar geniş bir yelpazede hizmet veriyoruz. Böylece siz de işinize odaklanabilir, teknik detayları bize bırakabilirsiniz.</p>
      <p>WordPress sitenizin potansiyelini en üst düzeye çıkarmak ve dijitalde daha güçlü bir varlık göstermek için bize güvenebilirsiniz.</p>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput 
              type="text" 
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required 
            />
            <ContactInput 
              type="tel" 
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required 
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>

    </ServiceDetailPageContainer>
  );
}

export default WordPressServices; 